import React from "react";
import classNames from "classnames";
import _ from "lodash";
import classes from "./DurationDropdown.scss";

export const DurationDropdownOverlay = ({
  durationMenus,
  durationMenuList,
  setIsDropdownVisible,
}) => {
  return (
    <div className={classes.dropdownOverlayContainer}>
      {_.map(
        durationMenus,
        ({ key, label, options, updateInputField, value }) => {
          return (
            <div key={key} className={classes.durationMenuContainer}>
              <div className={classes.durationMenuHeaderItem}>
                <div
                  className={classNames(
                    "text-label-2",
                    classes.durationHeaderLabel
                  )}
                >
                  {label}
                </div>
              </div>
              <div className={classes.durationMenuScrollContainer}>
                {_.map(options, option => {
                  const durationMenuItemClasses = classNames({
                    [classes.durationMenuItem]: true,
                    [classes.selectedDurationItem]: option == value,
                  });

                  return (
                    <div
                      key={option}
                      className={durationMenuItemClasses}
                      onClick={() => {
                        updateInputField(option);
                        if (key === "minutes") {
                          setIsDropdownVisible(false);
                        }
                      }}
                      ref={ref =>
                        (durationMenuList.current[`${key}-${option}`] = ref)
                      }
                    >
                      <div
                        className={classNames(
                          "text-body-1",
                          classes.durationOptionLabel
                        )}
                      >
                        {_.padStart(option, 2, "0")}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        }
      )}
    </div>
  );
};
